import LazyLoadImages from "./components/LazyLoadImages";
import ScrollTo from "./components/ScrollTo";

import './components/Popper';
import './components/DatePicker';

document.addEventListener('DOMContentLoaded', e => {
    window.lazy = new LazyLoadImages();

    new ScrollTo();

    if(document.querySelector('.error-alert')) { // if there are errors
        window.scrollToElement('.error-alert', { offset: -100 }) // scroll to the first error
    }
})

window.addEventListener("resize", () => { window.lazy.update(); });

